import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Truck, Loader2, LogIn } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate("/admin"); }, [user]);
  useEffect(() => {
    const err = new URLSearchParams(window.location.search).get("error");
    if (err) toast.error(err);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(email, password); navigate("/admin"); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center px-5 bg-slate-950">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 justify-center mb-6">
          <div className="h-10 w-10 rounded-lg bg-violet-600 grid place-items-center glow-violet"><Truck className="h-5 w-5 text-white" /></div>
          <span className="font-display font-extrabold text-xl">Escape Room Express</span>
        </div>
        <div className="rounded-2xl border border-white/10 bg-[#131a29] p-6">
          <h1 className="font-display font-bold text-2xl mb-1">Admin sign in</h1>
          <p className="text-sm text-slate-400 mb-5">Manage games, slots, bookings & leaderboards.</p>
          <form onSubmit={submit} className="space-y-3">
            <Input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-slate-950/50 border-white/10" />
            <Input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-slate-950/50 border-white/10" />
            <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-violet-600 hover:bg-violet-500">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><LogIn className="h-4 w-4 mr-2" /> Sign in</>}
            </Button>
          </form>
          <div className="my-4 flex items-center gap-3 text-xs text-slate-500"><div className="h-px bg-white/10 flex-1" /> or <div className="h-px bg-white/10 flex-1" /></div>
          <Button data-testid="login-google" onClick={google} variant="secondary" className="w-full">Continue with Google</Button>
        </div>
      </div>
    </div>
  );
}
